module.exports = __webpack_public_path__ + "stylesheets/video-player_0385aeff7fabf555dbe5a4107c6bef3e.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/video-player.less
// module id = pbA1
// module chunks = 151